(function () {
    "use strict";

    /**
     * Set this elements height to mimic the
     * viewports height.
     * @param  object options   Modify default options
     * @return jQuery Object    Element (chaining)
     */
    jQuery.fn.fullHeight = function (options) {

        // Merge provided options with
        // some default options
        options = jQuery.extend({
            // Default options
            match: window,
            ratio: 1
        }, options);

        // Get the viewports height
        var height = jQuery(window).height(),
            // Throttled timer for recalculating on resize
            resizeFullHeightTimer,
            // Store `this` so it's available within timer
            self = this;

        jQuery(this).each(function () {

            // If the element has a value for data attribute
            // then use it as the ratio
            if (jQuery(this).data('full-height')) {
                options.ratio = jQuery(this).data('full-height');
            }

            // Height of the new element based on ratio
            height = height * parseFloat(options.ratio);

            // Set the elements height
            jQuery(this).height(height);
        });

        // When the viewport changes
        jQuery(window).resize(function () {
            // Reset the existing timer (Throttle)
            clearTimeout(resizeFullHeightTimer);
            // Set the timer up again
            resizeFullHeightTimer = setTimeout(function () {
                // Re-run this function with the options
                jQuery(self).fullHeight(options);
            }, 100);
        });

        // Recalculate on full load
        jQuery(window).load(function () {
            // Re-run this function with the options
            jQuery(self).fullHeight(options);
        });

        // Return the jQuery element
        return this;
    };

}());
